import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import OrderHeader from '../../OrderHeader';
import LastFooter from '../../LastFooter';

import styles from './index.module.sass';

export default function MagazineSuccess({ history, screenSize }) {
  const { t } = useTranslation('digitalOrders');

  useEffect(() => {
    setTimeout(function () {
      return history.push('/cart/consultancy/home/');
    }, 5000);
  }, [history]);

  return (
    <div className={styles.magazinesuccess}>
      <OrderHeader />
      <div className={styles.container}>
        <div className={styles.ticketTitle}>
          <i className={`material-icons-outlined ${styles.doneIcon}`}>task_alt</i>
          <div className={styles.doneTitle}>{t('magazineSuccess')}</div>
        </div>
        <div className={styles.ticketMessage}>{t('magazineRedirect')}</div>
      </div>
      <LastFooter screenSize={screenSize} />
    </div>
  );
}
